import * as React from 'react';
import { RouteComponentProps, Link } from 'react-router-dom';
import { fetchApi } from '../../services/api';

export default function teacherBreadcrumb<T extends RouteComponentProps>(WrappedComponent: React.ComponentType<T>, options = {}) {

    type State = {
        teacherName: string;
    }

    type Props = RouteComponentProps<{ teacherId: string }>;

    return class extends React.Component<Props, State> {

        constructor(props: Props)
        {
            super(props);

            this.state = {
                teacherName: ''
            }

            this.fetchFacilityName = this.fetchFacilityName.bind(this);
        }

        componentDidMount() {
            this.fetchFacilityName(parseInt(this.props.match.params.teacherId));
        }

        componentWillReceiveProps(nextProps: Props) {
            const currentPage = this.props.location.pathname;
            const nextPage = nextProps.location.pathname;

            if (currentPage !== nextPage) {
                this.fetchFacilityName(parseInt(nextProps.match.params.teacherId));
            }
        }

        render() {
            return <React.Fragment>
                <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <Link to='/teachers'>Teachers</Link>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">{this.state.teacherName}</li>
                </ol>
                </nav>
                <WrappedComponent {...(this.props as T)} />
            </React.Fragment>
            ;
        }

        private fetchFacilityName(teacherId: number) {
            if (teacherId == 0) {
                this.setState({ teacherName: "New Teacher" })
            } else {
                fetchApi(`/api/Breadcrumb/Teacher/${teacherId}`)
                    .then((teacherName) => this.setState({ teacherName }))
            }
        };
    };
}
